// src/context/HomeFabContext.jsx
import { createContext, useState, useContext } from "react";

const HomeFabContext = createContext();

export function HomeFabProvider({ children }) {
  const [disableHomeFab, setDisableHomeFab] = useState(false);

  return (
    <HomeFabContext.Provider value={{ disableHomeFab, setDisableHomeFab }}>
      {children}
    </HomeFabContext.Provider>
  );
}

export function useHomeFab() {
  return useContext(HomeFabContext);
}
